import React, { useEffect, useState } from "react";
import "../Styles/OurNews.css";
import useFirestoreCollection from "../utils/useFirestoreCollection";

const OurNews = () => {
  const [phrases, setPhrases] = useState([]);
  const { loading: adminLoading, data: adminData } = useFirestoreCollection(
    "administration"
  );

  useEffect(() => {
    if (adminData && adminData.length > 0) {
      const raw = adminData[0].news;
      // Backward compatible: accept a single string or an array of phrases.
      const arr = Array.isArray(raw) ? raw : raw ? [raw] : [];
      setPhrases(
        arr
          .map((p) => (p || "").trim())
          .filter(Boolean)
          .slice(0, 3)
      );
    }
  }, [adminData]);

  // Hide the bar entirely while loading or when there's nothing to announce
  if (adminLoading) return null;
  if (!phrases.length) return null;

  return (
    <aside
      className="news-ticker"
      role="region"
      aria-label="Latest news"
      aria-live="polite"
    >
      <div className="news-ticker__label">
        <span className="news-ticker__dot" aria-hidden="true"></span>
        <span className="news-ticker__label-text">NEWS</span>
      </div>
      <div className="news-ticker__viewport">
        <div className="news-ticker__track">
          {phrases.map((phrase, i) => (
            <span className="news-ticker__item" key={i}>
              {phrase}
            </span>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default OurNews;
